import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Loader from "../../components/loader";
import UiButton from "../../components/button";
import TextInput from "../../components/textinput/TextInput";
import {
  SecuritiesFactory,
  contractAddress,
} from "@verified-network/verified-sdk";

import {
  useSupportedTokens,
  useIntermediaryList,
  useNetworkOptions,
  useCustodianData,
} from "../../context/contractDataLoaderService";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { shortAddress } from "../../components/common/CommonHeader";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  NULL_ADDRESS,
  countryList,
  countryDetails,
  getCountryName,
  getCountryCode,
  productCategory,
  networks,
  MarginIssueCategoryMarkers,
  supportedCountries,
} from "../../utils/constants";
import Select from "react-select";
import { useGlobal, fetchSumsubAccessToken } from "../../context/globalContext";
import { toast } from "react-toastify";
import { ethers, providers } from "ethers";
import "react-toastify/dist/ReactToastify.css";
import Web3 from "web3";
import ERC20 from "../../utils/abi/ERC20.json";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { getKycStatus } from "../../utils/helpers";

function NewIssue(props) {
  const history = useHistory();
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    kycStatus,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  const [loading, setLoading] = useState(false);
  const productType = ["Qualified", "Retail"];
  const [country, setCountry] = useState("");
  const [countryName, setCountryName] = useState("");
  const [showCustodian, setShowCustodian] = useState(false);
  let { data: intermediaryList, loading: intermediaryLoading } =
    useIntermediaryList(country, "DP");
  const [restrictedCountries, setRestrictedCountries] = useState([]);
  const [custodian, setCustodian] = useState(null);
  const { data: custodianList } = useIntermediaryList(country, "Custodian");
  const { data: networkOptions } = useNetworkOptions();
  let { data: currencySupported } = useSupportedTokens();
  let factoryContract;
  let marginIntermediaryList = [];
  const abiCoder = new ethers.utils.AbiCoder();
  const { data: custodianData } = useCustodianData(custodian);
  const currencyList = custodianData?.map((data) => {
    return {
      tokenAddress: data.issueCurrencyAddress,
      tokenName: data.issueCurrency,
    };
  });
  let currencySupportedList;

  if (currencySupported) {
    currencySupportedList = [
      ...currencySupported?.filter((token) => !token.isFiat),
    ];
    if (currencyList) {
      currencySupportedList.push(...currencyList);
    }
  }

  if (signer && chainId) {
    factoryContract = new SecuritiesFactory(
      signer,
      contractAddress[chainId].SecuritiesFactory,
    );
  }
  if (intermediaryList && intermediaryList.length > 0) {
    marginIntermediaryList = intermediaryList.filter(
      (manager) => manager.address.toLowerCase() !== account.toLowerCase(),
    );
  }
  useEffect(() => {
    if (
      props.intermediary &&
      !MarginIssueCategoryMarkers.includes(props.productCategory)
    ) {
      setShowCustodian(true);
    }
  }, [props.intermediary, props.productCategory]);

  const addNewIssue = async () => {
    const userKycStatus = await getKycStatus(address, chainId, web3);
    if (userKycStatus !== 3) {
      const data = await fetchSumsubAccessToken(account, chainId);
      console.log("return");
      props.setShowModal(false);
      props.setshowKYCModal(true);
      props.setAccessToken(data.accessToken);
      return;
    }

    if (props.companyName.length === 0) {
      toast.error(FailureToast("", "Enter Company name"), ToastOptions);
      return;
    } else if (props.companyName.length > 32) {
      toast.error(
        FailureToast("", "Keep company name length < 32"),
        ToastOptions,
      );
      return;
    } else if (props.isinValue.length === 0) {
      toast.error(FailureToast("", "Enter company symbol"), ToastOptions);
      return;
    } else if (props.currency === "Select Currency") {
      toast.error(FailureToast("", "Select currency to pair"), ToastOptions);
      return;
    } else if (props.productType === "Select type") {
      toast.error(FailureToast("", "Select product type"), ToastOptions);
      return;
    } else if (props.productCategory === "Select category") {
      toast.error(FailureToast("", "Select product category"), ToastOptions);
      return;
    } else if (country.length === 0) {
      toast.error(FailureToast("", "Select issuer country"), ToastOptions);
      return;
    } else if (!props.intermediary) {
      toast.error(FailureToast("", "Select issue manager"), ToastOptions);
      return;
    }

    const selectedCurrency = currencySupportedList.find(
      (token) => token.tokenAddress === props.currency,
    );
    const productCategory = ethers.utils.formatBytes32String(
      props.productCategory,
    );
    const issuingCountry = ethers.utils.formatBytes32String(country);
    const restrictedCountryList = restrictedCountries.map((countryName) => {
      if (countryName.code !== "") {
        return ethers.utils.formatBytes32String(countryName.code);
      }
    });

    const restrictedCountryListEncoded = abiCoder.encode(
      ["bytes32[]"],
      [restrictedCountryList],
    );
    setLoading(true);
    try {
      let securityAddress;
      await factoryContract
        .issueSecurity(
          NULL_ADDRESS,
          productCategory,
          props.companyName,
          props.isinValue,
          selectedCurrency.tokenAddress,
          account,
          props.intermediary.address,
          restrictedCountryListEncoded,
          issuingCountry,
          props.productType === "Qualified" ? 1 : 0,
          networkOptions,
        )
        .then(async (res) => {
          if (res?.status === 0) {
            const response = await factoryContract.getIssues();
            securityAddress = response.response.result.at(-1);
            props.updateSecurity(securityAddress);
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            if (
              showCustodian &&
              custodian &&
              securityAddress &&
              props.intermediary.address.toLowerCase() === account.toLowerCase()
            ) {
              const custodianTX = await factoryContract.setCustodian(
                securityAddress,
                account,
                custodian,
                networkOptions,
              );
              if (custodianTX.code === "ACTION_REJECTED") {
                toast.error("Transaction rejected by user!", ToastOptions);
              } else {
                setLoading(false);
                const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${custodianTX?.response?.hash}`;
                toast.success(SuccessToast(transactionLink), ToastOptions);
                props.updateModalView(2);
              }
            }
            setLoading(false);
            if (!MarginIssueCategoryMarkers.includes(props.productCategory)) {
              props.updateModalView(2);
            } else {
              props.updateModalView(5);
            }
          } else if (res?.code === "ACTION_REJECTED") {
            toast.error("Transaction rejected by user!", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err.transactionHash}`;
      setLoading(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}

      <div className="d-grid gap-2">
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Company Name</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Security token name"
                value={props.companyName}
                required
                onChange={(e) => props.updateCompanyName(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Security Symbol</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Security token symbol"
                value={props.isinValue}
                required
                onChange={(e) => {
                  props.updateIsinValue(e.target.value);
                  props.updateSecuritySymbol(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Target client</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DropdownButton
                id="dropdown-basic-button"
                title={props.productType}
              >
                {productType?.map((type, id) => (
                  <Dropdown.Item
                    key={id}
                    onClick={(e) => props.updateProductType(type)}
                  >
                    {type}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Product Category</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DropdownButton
                id="dropdown-basic-button"
                title={props.productCategory}
              >
                {productCategory?.map((type, id) => (
                  <Dropdown.Item
                    key={id}
                    onClick={(e) => props.updateProductCategory(type)}
                  >
                    {type}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Country</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <Select
                options={supportedCountries.map((country, id) => {
                  return {
                    value: country.name,
                    label: country.name,
                    code: country.code,
                  };
                })}
                isMulti={false}
                value={countryName}
                onChange={(selected) => {
                  setCountry(selected.code);
                  setCountryName(selected.name);
                }}
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Issue manager</b>
            </Col>
            {!MarginIssueCategoryMarkers.includes(props.productCategory) && (
              <Col className="pl-0" xs={5}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title={
                    props.intermediary
                      ? shortAddress(props.intermediary.address)
                      : "Select issue manager"
                  }
                >
                  {intermediaryList?.map((manager) => (
                    <Dropdown.Item
                      key={manager.address}
                      onClick={(e) => props.updateIntermediary(manager)}
                    >
                      <b>{manager.name}</b>&nbsp;(
                      {shortAddress(manager.address)})
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
            )}
            {MarginIssueCategoryMarkers.includes(props.productCategory) && (
              <Col className="pl-0" xs={5}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title={
                    props.intermediary
                      ? shortAddress(props.intermediary.address)
                      : "Select issue manager"
                  }
                >
                  {marginIntermediaryList?.map((manager) => (
                    <Dropdown.Item
                      key={manager.address}
                      onClick={(e) => props.updateIntermediary(manager)}
                    >
                      <b>{manager.name}</b>&nbsp;(
                      {shortAddress(manager.address)})
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
            )}
          </Row>
          {showCustodian && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Custodian</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title={
                    custodianList
                      ? custodianList.length
                        ? custodian
                          ? shortAddress(custodian)
                          : "Select custodian"
                        : "Select custodian"
                      : null
                  }
                >
                  {custodianList ? (
                    custodianList.length ? (
                      custodianList?.map((manager) => (
                        <Dropdown.Item
                          key={manager.address}
                          onClick={(e) => setCustodian(manager.address)}
                        >
                          <b>{manager.name}</b>&nbsp;(
                          {shortAddress(manager.address)})
                        </Dropdown.Item>
                      ))
                    ) : (
                      <span className="p-2">
                        {country ? "No custodian present" : "Select a country"}
                      </span>
                    )
                  ) : null}
                </DropdownButton>
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Currency to pair</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DropdownButton
                id="dropdown-basic-button"
                title={
                  currencySupportedList?.find(
                    (data) => data.tokenAddress === props.currency,
                  )
                    ? currencySupportedList?.find(
                        (data) => data.tokenAddress === props.currency,
                      )?.tokenName
                    : "Select Currency"
                }
              >
                {currencySupportedList?.map((token, id) => (
                  <Dropdown.Item
                    key={id}
                    onClick={async (e) => {
                      props.updateCurrency(token?.tokenAddress);
                      const currencySymbol = await new web3.eth.Contract(
                        ERC20,
                        token?.tokenAddress,
                      ).methods
                        .symbol()
                        .call();
                      props.updateCurrencySymbol(currencySymbol);
                    }}
                  >
                    {token?.tokenName}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Restricted Countries</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <Select
                options={countryDetails.map((cont) => {
                  if (cont.code.toLowerCase() !== country.toLowerCase()) {
                    return {
                      value: cont.name,
                      label: cont.name,
                      code: cont.code,
                    };
                  } else {
                    return {
                      value: "",
                      label: "",
                      code: "",
                    };
                  }
                })}
                isMulti
                value={restrictedCountries}
                onChange={(selected) => setRestrictedCountries(selected)}
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  addNewIssue();
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Create Issue"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export default function AddIssue(props) {
  return <NewIssue {...props} />;
}
